import './index.less'
import Qiyun from './SixLawsPanel/Qiyun'
import Gufa from './SixLawsPanel/Gufa'
import Wuxiang from './SixLawsPanel/Wuxiang'
import Fucai from './SixLawsPanel/Fucai'
import WeizhiThumbnail from './SixLawsPanel/WeizhiThumbnail'
import ChuanyiThumbnail from './SixLawsPanel/ChuanyiThumbnail'
import Chuanyi from './ChuanyiPanel/Chuanyi'
import Weizhi from './WeizhiPanel/Weizhi'
import { useEffect as _useEffect, useState } from 'react'
import { getImgsInfoByImgID as _getImgsInfoByImgID } from '@/server'
import { useAppSelector as _useAppSelector } from '@/hooks'
export interface similarImgsInfoI {
  title: string
  similarity: number
  author: string
  imgSrc: string
  dynasty: string
}

//谢赫六法
export function SixLawsPage(props) {
  const [showPanel, setShowPanel] = useState<number>(0) //0:展示谢赫六法；1:展示传移模写；2:展示经营位置
  const similarImgsInfo = props.similarImgsInfo

  return showPanel === 0 ? (
    <div className='sixlaws-panel'>
      <Qiyun />
      <Gufa />
      <Wuxiang />
      <Fucai />
      <div className='weizhi-chuanyi'>
        <WeizhiThumbnail setShowPanel={setShowPanel} />
        <ChuanyiThumbnail
          setShowPanel={setShowPanel}
          similarImgsInfo={similarImgsInfo.slice(0, 3)}
        />
      </div>
    </div>
  ) : showPanel === 1 ? (
    <Chuanyi setShowPanel={setShowPanel} similarImgsInfo={similarImgsInfo} />
  ) : (
    <Weizhi setShowPanel={setShowPanel} />
  )
}
